import React from 'react'
import { Stack } from '@mui/material'
import { UseFieldArrayRemove } from 'react-hook-form'
import DateFrame from './DateFrame'
import { Field } from 'src/Libs/dynamic-tariff-settings/model'

interface Props {
  name: string
  fields: Field[]
  remove: UseFieldArrayRemove
  hasWritingRights: boolean
}

/**
 * Component to add DateFrame to react-hook-form field array
 */
const DateFrameList: React.FC<Props> = ({ name, fields, remove, hasWritingRights }) => {
  return (
    <Stack>
      {fields.map((field, index) => {
        const onRemove = (): void => {
          remove(index)
        }
        const dateFrameName = `${name}.${index}`
        return <DateFrame key={field.id} dateFrameName={dateFrameName} onRemove={onRemove} hasWritingRights={hasWritingRights} />
      })}
    </Stack>
  )
}

export default DateFrameList
